import { render, staticRenderFns } from "./VideoJs.vue?vue&type=template&id=15323176&scoped=true"
import script from "./VideoJs.vue?vue&type=script&lang=js"
export * from "./VideoJs.vue?vue&type=script&lang=js"
import style0 from "./VideoJs.vue?vue&type=style&index=0&id=15323176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15323176",
  null
  
)

export default component.exports